import { render } from "./TableForm.vue?vue&type=template&id=6ebe08ac&scoped=true"
import script from "./TableForm.vue?vue&type=script&lang=js"
export * from "./TableForm.vue?vue&type=script&lang=js"

import "./TableForm.vue?vue&type=style&index=0&id=6ebe08ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebe08ac"]])

export default __exports__